import React from 'react';
import { ReviewSection } from '../../sections';

const ReviewPage = () => {
  return (
    <div>
      <ReviewSection />
    </div>
  );
};

export default ReviewPage;
